import type { LocalizationRule, PermissionRole } from "./types";

export const permissionRoles: PermissionRole[] = [
  {
    id: "owner",
    role: "Owner",
    scope: "All branches, budgets, users, suppliers, and exports",
    users: 2,
    approvalLimit: "Unlimited",
    canApproveOrders: true,
    canSubmitOrders: true,
    canManageSupplierDesk: true,
    canExportFinance: true,
    canManageBudgetControls: true,
    canManageWorkspace: true,
  },
  {
    id: "buyer",
    role: "Restaurant staff",
    scope: "Assigned locations, usual suppliers, repeat orders",
    users: 18,
    approvalLimit: "900 BAM",
    canApproveOrders: true,
    canSubmitOrders: true,
    canManageSupplierDesk: false,
    canExportFinance: false,
    canManageBudgetControls: false,
    canManageWorkspace: false,
  },
  {
    id: "finance",
    role: "Finance",
    scope: "Invoices, exports, audit logs, budget controls",
    users: 4,
    approvalLimit: "Review only",
    canApproveOrders: false,
    canSubmitOrders: false,
    canManageSupplierDesk: false,
    canExportFinance: true,
    canManageBudgetControls: true,
    canManageWorkspace: false,
  },
  {
    id: "supplier-sales",
    role: "Supplier operator",
    scope: "Price requests, orders, invoices, product availability, restaurant messages",
    users: 36,
    approvalLimit: "Supplier account only",
    canApproveOrders: false,
    canSubmitOrders: false,
    canManageSupplierDesk: true,
    canExportFinance: true,
    canManageBudgetControls: false,
    canManageWorkspace: false,
  },
];

export const localizationRules: LocalizationRule[] = [
  {
    id: "loc-ba",
    market: "Bosnia and Herzegovina",
    currency: "BAM",
    taxMode: "VAT 17%",
    language: "bs / en",
    status: "live",
  },
  {
    id: "loc-eu",
    market: "EU markets",
    currency: "EUR",
    taxMode: "Market-specific VAT",
    language: "en / de / hr",
    status: "live",
  },
  {
    id: "loc-gcc",
    market: "GCC",
    currency: "AED / SAR / QAR",
    taxMode: "Tax-inclusive contracts",
    language: "en / ar",
    status: "review",
  },
];
